// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `calendar current date border bottom .rdrDayToday .rdrDayNumber span:after {
  bottom: 0px !important;
}

.table > :not(caption) > * > * {
  padding-right: 10px !important;
}
.product-update-details {
  gap: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
}
.product-update-details-row {
  background-color: #f7f8fb;
  border: 1px solid #fd7e14;
  padding: 12px 20px 0px 20px;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease-in-out;
}
.product-update-details-row:hover {
  background-color: #fd7e14;
  border-radius: 5px;
  transition: 0.5s;
}
.product-update-details-row:hover p {
  color: #fff;
  transition: 0.5s;
}
.product-update-details-row-label {
  font-weight: 400;
}
.product-update-details-text {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
}
.update {
  font-weight: 600;
}
.section-header {
  font-size: 20px;
  font-weight: 600;
}
.error-message {
  font-size: 16px;
  font-weight: 600;
}
.trafficsource_chart::after {
  display: none;
}
.progress {
  height: 1.5em !important;
}
.progress-bar {
  background-color: #fd7e14 !important;
}
.excel-btn {
  background-color: #1c6c3f !important;
}
.notify {
  width: 13px;
  height: 13px;
  border-radius: 100%;
  background-color: red;
  color: white;
  position: absolute;
  z-index: 2;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  left: 2px;
}
.transition-colors {
  /* background-color: #fef2f2; */
  color: #6b7280;
  transition-duration: 150ms;
}
.transition-colors:hover {
  background-color: #d1d5db;
  transition-duration: 150ms;
  cursor: pointer;
}
.transition-colors p {
  color: #6b7280;
}

/* Blog Content Grid Layout */
.blog-content-grid {
  --container-gap: 1rem;
  --container-width: 1200px;
  --content-width: 720px;

  display: grid;
  grid-template-columns:
    [full-start] minmax(var(--container-gap), 1fr)
    [wide-start] minmax(
      0,
      calc((var(--container-width, 1200px) - var(--content-width, 720px)) / 2)
    )
    [main-start] min(
      var(--content-width, 720px),
      100% - var(--container-gap) * 2
    )
    [main-end] minmax(
      0,
      calc((var(--container-width, 1200px) - var(--content-width, 720px)) / 2)
    )
    [wide-end] minmax(var(--container-gap), 1fr)
    [full-end];
}

.blog-content p,
strong,
em,
u,
a,
ul,
,
ol,
li {
  font-size: 17px;
}
.blog-content-main {
  grid-column: main-start / main-end;
}

/* Style the actual content */
.blog-content {
  width: 100%;
  line-height: 1.6;
  color: #333;
}

/* Optional: Style images within blog content */
.blog-content img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1rem auto;
  border-radius: 8px;
}

/* Optional: Style code blocks */
.blog-content pre {
  background-color: #f5f5f5;
  padding: 1rem;
  border-radius: 8px;
  overflow-x: auto;
}

/* Optional: Style blockquotes */
.blog-content blockquote {
  border-left: 4px solid #f57c21;
  margin: 1rem 0;
  padding-left: 1rem;
  font-style: italic;
  color: #666;
}

/* Optional: Style tables */
.blog-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
}

.blog-content th,
.blog-content td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.blog-content th {
  background-color: #f2f2f2;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .blog-content-grid {
    --container-gap: 1rem;
  }

  .blog-content-main {
    grid-column: full-start / full-end;
    padding: 0 1rem;
  }
}

/* If you want wide images to span the wide columns */
.blog-content img.wide {
  grid-column: wide-start / wide-end;
  width: 100%;
}

/* If you want full-width images */
.blog-content img.full {
  grid-column: full-start / full-end;
  width: 100%;
}

/* Grid layout for Quill Editor - same as blog content display */
.quill-editor-grid {
  --container-gap: 1rem;
  --container-width: 1200px;
  --content-width: 720px;

  display: grid;
  grid-template-columns:
    [full-start] minmax(var(--container-gap), 1fr)
    [wide-start] minmax(
      0,
      calc((var(--container-width, 1200px) - var(--content-width, 720px)) / 2)
    )
    [main-start] min(
      var(--content-width, 720px),
      100% - var(--container-gap) * 2
    )
    [main-end] minmax(
      0,
      calc((var(--container-width, 1200px) - var(--content-width, 720px)) / 2)
    )
    [wide-end] minmax(var(--container-gap), 1fr)
    [full-end];
}

.quill-editor-main {
  grid-column: main-start / main-end;
}

/* Style the Quill editor content area to match the display */
.quill-editor-main .ql-container {
  font-size: 16px;
  line-height: 1.6;
}

/* Ensure images in the editor have proper sizing */
.quill-editor-main .ql-editor img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1rem auto;
}

/* Style the editor content area */
.quill-editor-main .ql-editor {
  font-family: inherit;
  padding: 1rem;
}

/* Make the toolbar responsive */
.quill-editor-main .ql-toolbar {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
  border-radius: 4px 4px 0 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .quill-editor-grid {
    --container-gap: 1rem;
  }

  .quill-editor-main {
    grid-column: full-start / full-end;
    padding: 0 1rem;
  }
}

/* Optional: Add a preview mode toggle */
.quill-editor-preview {
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-top: 1rem;
}

/* Style for the editor when in fullscreen mode (if needed) */
.ql-container.ql-snow {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

@media screen and (max-width: 425px) {
  .product-update-details-row {
    padding: 12px 12px 0px 12px;
  }
}

.card-line {
  margin: 5px -13px !important;
}

.partner-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  background-color: #fff;
  padding: 10px;
}
.partner-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}
.nav-tabs .nav-link.active-tab {
  background-color: #fff;
  font-weight: 600;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
/* Style for optgroup labels */
.country-optgroup {
  background-color: #f0f0f0;
  color: #333;
  font-weight: bold;
  font-style: normal;
  padding: 5px;
}

/* Style for options */
.country-optgroup option {
  padding-left: 20px;
  background-color: white;
  color: #555;
}
.react-tel-input .form-control {
  width: 100% !important;
}
.table-responsive {
  overflow: visible !important;
}

.dropdown-menu {
  position: absolute;
  z-index: 1000;
  right: 0;
  left: auto;
}

/* For mobile filters */
/* Add to your mobile filters CSS */
.mobile-filters::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

@media (max-width: 1024px) {
  .mobile-filters {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1050;
    overflow-y: auto;
    background: white;
    padding: 1rem;
  }

  .mobile-filters .card {
    height: auto;
    max-height: 100%;
    overflow-y: auto;
  }
}

.custom-dropdown {
  position: relative;
  display: inline-block;
}

.custom-dropdown-btn {
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.dropdown-arrow {
  font-size: 10px;
  transition: transform 0.2s;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}
.custom-dropdown-menu-two {
  position: absolute;
  right: 0;
  top: 100%;
  min-width: 200px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
  list-style: none;
  padding: 8px 0;
  margin: 4px 0 0;
}

.custom-dropdown-menu {
  position: absolute;
  right: 0;
  top: 100%;
  min-width: 200px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
  list-style: none;
  padding: 8px 0;
  margin: 4px 0 0;
}

.custom-dropdown-item {
  display: block;
  padding: 8px 16px;
  color: #333;
  text-decoration: none;
  transition: background 0.2s;
}

/* Modern Address Display Styling */
.address-display {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
}

.address-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.address-item {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.address-label {
  font-size: 0.875em;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
}

.address-value {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e293b;
  display: flex;
  align-items: center;
}

/* Optional: Add icons for better visual cues */
.address-item:nth-child(1) .address-label::before {
  content: "🌎";
  margin-right: 6px;
}

.address-item:nth-child(2) .address-label::before {
  content: "🗺️";
  margin-right: 6px;
}

.address-item:nth-child(3) .address-label::before {
  content: "🏙️";
  margin-right: 6px;
}

.address-item:nth-child(4) .address-label::before {
  content: "📮";
  margin-right: 6px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .address-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
}
.status-badge {
  transition: all 0.2s ease;
}

.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bg-amber-600 {
  background-color: #d97706;
}
.bg-purple-500 {
  background-color: #8b5cf6;
}

/* Background colors */
.bg-blue-100 {
  background-color: #dbeafe !important;
}
.bg-blue-200 {
  background-color: #c1d9f8 !important;
}
.bg-amber-100 {
  background-color: #fef3c7 !important;
}
.bg-indigo-100 {
  background-color: #e0e7ff !important;
}
.bg-gray-100 {
  background-color: #f3f4f6 !important;
}
.bg-purple-100 {
  background-color: #f3e8ff !important;
}
.bg-teal-100 {
  background-color: #ccfbf1 !important;
}
.bg-green-100 {
  background-color: #d1fae5 !important;
}
.bg-red-100 {
  background-color: #fee2e2 !important;
}
.bg-orange-100 {
  background-color: #ffedd5 !important;
}
.bg-yellow-100 {
  background-color: #fef9c3 !important;
}

/* Text colors */
.text-blue-800 {
  color: #1e40af !important;
}
.text-blue-900 {
  color: #1a3daf !important;
}
.text-amber-800 {
  color: #92400e !important;
}
.text-indigo-800 {
  color: #3730a3 !important;
}
.text-gray-800 {
  color: #1f2937 !important;
}
.text-purple-800 {
  color: #6b21a8 !important;
}
.text-teal-800 {
  color: #115e59 !important;
}
.text-green-800 {
  color: #065f46 !important;
}
.text-red-800 {
  color: #991b1b !important;
}
.text-orange-800 {
  color: #9a3412 !important;
}
.text-yellow-800 {
  color: #854d0e !important;
}
.badge {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-dropdown-menu {
  display: none;
}
.custom-dropdown-menu.show {
  display: block;
}
.custom-dropdown-menu-two.show {
  display: block;
}
.dropdown-button {
  display: flex;
  align-items: center;
  padding: 2px 0;
  background-color: #fff;
  border: none;
  cursor: pointer;
}
/* React Quill Custom Styles */
.ql-container {
  font-family: inherit;
  font-size: 14px;
}

.ql-editor {
  min-height: 200px;
}

.ql-toolbar {
  border-radius: 4px 4px 0 0;
  border-color: #dee2e6 !important;
}

.ql-container {
  border-radius: 0 0 4px 4px;
  border-color: #dee2e6 !important;
}

.ql-editor.ql-blank::before {
  font-style: normal;
  color: #6c757d;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;AACA;EACE,+BAA+B;EAC/B,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;;EAEtB,aAAa;EACb;;;;;;;;;;;;;;;cAeY;AACd;;AAEA;;;;;;;;;EASE,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,kCAAkC;IAClC,eAAe;EACjB;AACF;;AAEA,qDAAqD;AACrD;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;;EAEtB,aAAa;EACb;;;;;;;;;;;;;;;cAeY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,kCAAkC;IAClC,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC;;wBAEsB;EACtB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;AAEA,uBAAuB;AACvB,mCAAmC;AACnC;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE;;;;cAIY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB","sourcesContent":["calendar current date border bottom .rdrDayToday .rdrDayNumber span:after {\n  bottom: 0px !important;\n}\n\n.table > :not(caption) > * > * {\n  padding-right: 10px !important;\n}\n.product-update-details {\n  gap: 10px;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 10px;\n}\n.product-update-details-row {\n  background-color: #f7f8fb;\n  border: 1px solid #fd7e14;\n  padding: 12px 20px 0px 20px;\n  width: 100%;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: 0.3s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  transition: all 0.3s ease-in-out;\n}\n.product-update-details-row:hover {\n  background-color: #fd7e14;\n  border-radius: 5px;\n  transition: 0.5s;\n}\n.product-update-details-row:hover p {\n  color: #fff;\n  transition: 0.5s;\n}\n.product-update-details-row-label {\n  font-weight: 400;\n}\n.product-update-details-text {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 14px;\n}\n.update {\n  font-weight: 600;\n}\n.section-header {\n  font-size: 20px;\n  font-weight: 600;\n}\n.error-message {\n  font-size: 16px;\n  font-weight: 600;\n}\n.trafficsource_chart::after {\n  display: none;\n}\n.progress {\n  height: 1.5em !important;\n}\n.progress-bar {\n  background-color: #fd7e14 !important;\n}\n.excel-btn {\n  background-color: #1c6c3f !important;\n}\n.notify {\n  width: 13px;\n  height: 13px;\n  border-radius: 100%;\n  background-color: red;\n  color: white;\n  position: absolute;\n  z-index: 2;\n  top: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  left: 2px;\n}\n.transition-colors {\n  /* background-color: #fef2f2; */\n  color: #6b7280;\n  transition-duration: 150ms;\n}\n.transition-colors:hover {\n  background-color: #d1d5db;\n  transition-duration: 150ms;\n  cursor: pointer;\n}\n.transition-colors p {\n  color: #6b7280;\n}\n\n/* Blog Content Grid Layout */\n.blog-content-grid {\n  --container-gap: 1rem;\n  --container-width: 1200px;\n  --content-width: 720px;\n\n  display: grid;\n  grid-template-columns:\n    [full-start] minmax(var(--container-gap), 1fr)\n    [wide-start] minmax(\n      0,\n      calc((var(--container-width, 1200px) - var(--content-width, 720px)) / 2)\n    )\n    [main-start] min(\n      var(--content-width, 720px),\n      100% - var(--container-gap) * 2\n    )\n    [main-end] minmax(\n      0,\n      calc((var(--container-width, 1200px) - var(--content-width, 720px)) / 2)\n    )\n    [wide-end] minmax(var(--container-gap), 1fr)\n    [full-end];\n}\n\n.blog-content p,\nstrong,\nem,\nu,\na,\nul,\n,\nol,\nli {\n  font-size: 17px;\n}\n.blog-content-main {\n  grid-column: main-start / main-end;\n}\n\n/* Style the actual content */\n.blog-content {\n  width: 100%;\n  line-height: 1.6;\n  color: #333;\n}\n\n/* Optional: Style images within blog content */\n.blog-content img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 1rem auto;\n  border-radius: 8px;\n}\n\n/* Optional: Style code blocks */\n.blog-content pre {\n  background-color: #f5f5f5;\n  padding: 1rem;\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n/* Optional: Style blockquotes */\n.blog-content blockquote {\n  border-left: 4px solid #f57c21;\n  margin: 1rem 0;\n  padding-left: 1rem;\n  font-style: italic;\n  color: #666;\n}\n\n/* Optional: Style tables */\n.blog-content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1rem 0;\n}\n\n.blog-content th,\n.blog-content td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\n.blog-content th {\n  background-color: #f2f2f2;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .blog-content-grid {\n    --container-gap: 1rem;\n  }\n\n  .blog-content-main {\n    grid-column: full-start / full-end;\n    padding: 0 1rem;\n  }\n}\n\n/* If you want wide images to span the wide columns */\n.blog-content img.wide {\n  grid-column: wide-start / wide-end;\n  width: 100%;\n}\n\n/* If you want full-width images */\n.blog-content img.full {\n  grid-column: full-start / full-end;\n  width: 100%;\n}\n\n/* Grid layout for Quill Editor - same as blog content display */\n.quill-editor-grid {\n  --container-gap: 1rem;\n  --container-width: 1200px;\n  --content-width: 720px;\n\n  display: grid;\n  grid-template-columns:\n    [full-start] minmax(var(--container-gap), 1fr)\n    [wide-start] minmax(\n      0,\n      calc((var(--container-width, 1200px) - var(--content-width, 720px)) / 2)\n    )\n    [main-start] min(\n      var(--content-width, 720px),\n      100% - var(--container-gap) * 2\n    )\n    [main-end] minmax(\n      0,\n      calc((var(--container-width, 1200px) - var(--content-width, 720px)) / 2)\n    )\n    [wide-end] minmax(var(--container-gap), 1fr)\n    [full-end];\n}\n\n.quill-editor-main {\n  grid-column: main-start / main-end;\n}\n\n/* Style the Quill editor content area to match the display */\n.quill-editor-main .ql-container {\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n/* Ensure images in the editor have proper sizing */\n.quill-editor-main .ql-editor img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 1rem auto;\n}\n\n/* Style the editor content area */\n.quill-editor-main .ql-editor {\n  font-family: inherit;\n  padding: 1rem;\n}\n\n/* Make the toolbar responsive */\n.quill-editor-main .ql-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: white;\n  border-radius: 4px 4px 0 0;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .quill-editor-grid {\n    --container-gap: 1rem;\n  }\n\n  .quill-editor-main {\n    grid-column: full-start / full-end;\n    padding: 0 1rem;\n  }\n}\n\n/* Optional: Add a preview mode toggle */\n.quill-editor-preview {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  margin-top: 1rem;\n}\n\n/* Style for the editor when in fullscreen mode (if needed) */\n.ql-container.ql-snow {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n@media screen and (max-width: 425px) {\n  .product-update-details-row {\n    padding: 12px 12px 0px 12px;\n  }\n}\n\n.card-line {\n  margin: 5px -13px !important;\n}\n\n.partner-card {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n  background-color: #fff;\n  padding: 10px;\n}\n.partner-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\n}\n.nav-tabs .nav-link.active-tab {\n  background-color: #fff;\n  font-weight: 600;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n}\n/* Style for optgroup labels */\n.country-optgroup {\n  background-color: #f0f0f0;\n  color: #333;\n  font-weight: bold;\n  font-style: normal;\n  padding: 5px;\n}\n\n/* Style for options */\n.country-optgroup option {\n  padding-left: 20px;\n  background-color: white;\n  color: #555;\n}\n.react-tel-input .form-control {\n  width: 100% !important;\n}\n.table-responsive {\n  overflow: visible !important;\n}\n\n.dropdown-menu {\n  position: absolute;\n  z-index: 1000;\n  right: 0;\n  left: auto;\n}\n\n/* For mobile filters */\n/* Add to your mobile filters CSS */\n.mobile-filters::before {\n  content: \"\";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: -1;\n}\n\n@media (max-width: 1024px) {\n  .mobile-filters {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1050;\n    overflow-y: auto;\n    background: white;\n    padding: 1rem;\n  }\n\n  .mobile-filters .card {\n    height: auto;\n    max-height: 100%;\n    overflow-y: auto;\n  }\n}\n\n.custom-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.custom-dropdown-btn {\n  background: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  transition: transform 0.2s;\n}\n\n.dropdown-arrow.open {\n  transform: rotate(180deg);\n}\n.custom-dropdown-menu-two {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  min-width: 200px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  list-style: none;\n  padding: 8px 0;\n  margin: 4px 0 0;\n}\n\n.custom-dropdown-menu {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  min-width: 200px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  list-style: none;\n  padding: 8px 0;\n  margin: 4px 0 0;\n}\n\n.custom-dropdown-item {\n  display: block;\n  padding: 8px 16px;\n  color: #333;\n  text-decoration: none;\n  transition: background 0.2s;\n}\n\n/* Modern Address Display Styling */\n.address-display {\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    sans-serif;\n}\n\n.address-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n\n.address-item {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n.address-label {\n  font-size: 0.875em;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  display: flex;\n}\n\n.address-value {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n}\n\n/* Optional: Add icons for better visual cues */\n.address-item:nth-child(1) .address-label::before {\n  content: \"🌎\";\n  margin-right: 6px;\n}\n\n.address-item:nth-child(2) .address-label::before {\n  content: \"🗺️\";\n  margin-right: 6px;\n}\n\n.address-item:nth-child(3) .address-label::before {\n  content: \"🏙️\";\n  margin-right: 6px;\n}\n\n.address-item:nth-child(4) .address-label::before {\n  content: \"📮\";\n  margin-right: 6px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .address-grid {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n}\n.status-badge {\n  transition: all 0.2s ease;\n}\n\n.status-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.bg-amber-600 {\n  background-color: #d97706;\n}\n.bg-purple-500 {\n  background-color: #8b5cf6;\n}\n\n/* Background colors */\n.bg-blue-100 {\n  background-color: #dbeafe !important;\n}\n.bg-blue-200 {\n  background-color: #c1d9f8 !important;\n}\n.bg-amber-100 {\n  background-color: #fef3c7 !important;\n}\n.bg-indigo-100 {\n  background-color: #e0e7ff !important;\n}\n.bg-gray-100 {\n  background-color: #f3f4f6 !important;\n}\n.bg-purple-100 {\n  background-color: #f3e8ff !important;\n}\n.bg-teal-100 {\n  background-color: #ccfbf1 !important;\n}\n.bg-green-100 {\n  background-color: #d1fae5 !important;\n}\n.bg-red-100 {\n  background-color: #fee2e2 !important;\n}\n.bg-orange-100 {\n  background-color: #ffedd5 !important;\n}\n.bg-yellow-100 {\n  background-color: #fef9c3 !important;\n}\n\n/* Text colors */\n.text-blue-800 {\n  color: #1e40af !important;\n}\n.text-blue-900 {\n  color: #1a3daf !important;\n}\n.text-amber-800 {\n  color: #92400e !important;\n}\n.text-indigo-800 {\n  color: #3730a3 !important;\n}\n.text-gray-800 {\n  color: #1f2937 !important;\n}\n.text-purple-800 {\n  color: #6b21a8 !important;\n}\n.text-teal-800 {\n  color: #115e59 !important;\n}\n.text-green-800 {\n  color: #065f46 !important;\n}\n.text-red-800 {\n  color: #991b1b !important;\n}\n.text-orange-800 {\n  color: #9a3412 !important;\n}\n.text-yellow-800 {\n  color: #854d0e !important;\n}\n.badge {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.custom-dropdown-menu {\n  display: none;\n}\n.custom-dropdown-menu.show {\n  display: block;\n}\n.custom-dropdown-menu-two.show {\n  display: block;\n}\n.dropdown-button {\n  display: flex;\n  align-items: center;\n  padding: 2px 0;\n  background-color: #fff;\n  border: none;\n  cursor: pointer;\n}\n/* React Quill Custom Styles */\n.ql-container {\n  font-family: inherit;\n  font-size: 14px;\n}\n\n.ql-editor {\n  min-height: 200px;\n}\n\n.ql-toolbar {\n  border-radius: 4px 4px 0 0;\n  border-color: #dee2e6 !important;\n}\n\n.ql-container {\n  border-radius: 0 0 4px 4px;\n  border-color: #dee2e6 !important;\n}\n\n.ql-editor.ql-blank::before {\n  font-style: normal;\n  color: #6c757d;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
